import { createAction } from 'redux-act'

import * as reports from '../../api/reports'

export const getSalesSummaryByPOS = createAction('GET_SALES_SUMMARY_POS', reports.salesSummaryByPOS)
